export const tabsMap = [
    {
        icon: 'icon-a-Slice4',
        title: '联系我们',
        titleMts: 'Header.ContactUs',
        key: 'contactUs',
    },
    {
        icon: 'icon-meitijuzhen',
        title: '媒体矩阵',
        titleMts: 'Header.MediaMatrix',
        key: 'media',
    },
    {
        icon: 'icon-guanyuwomen',
        title: '关于我们',
        titleMts: 'Header.AboutUs',
        key: 'aboutUs',
    },
];
